<template>
    <div class="box">
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th>店铺角色</th>
                    <th>姓名</th>
                    <th>手机号</th>
                </tr>
            </thead>
            <tbody v-if="GetReceivers">
                <tr v-for="(item,index) in GetReceivers.list" :key="index"  @click="checkbox(item.id)">
                    <td>
                        <div :style="[checkbox_index==item.id?on:off]" class="icon"></div>
                    </td>
                    <td>
                        {{item.role_name}}
                    </td>
                    <td>
                        <div>
                            {{item.receive_name}}
                        </div>
                    </td>
                    <td>
                        {{item.mobile?item.mobile:'无'}}
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="button_box">
            <router-link to="AddRecipientInfo">
                <div class="btn bgc_orange">添加接收人</div>
            </router-link>
            <div @click="submit" class="btn bgc_blue">确定</div>
        </div>
    </div>
</template>
<script>
import close_page from '@/utils/close_page';
import { mapState } from 'vuex';
import { Toast } from 'vant';
export default {
    name: 'AddRecipient',
    data(){
        return{
            checkbox_index:null,
            on:{
                backgroundImage:`url(${this.$OSSBaseUrl}checkbox_duihao.png)`,
                border:'1px solid rgb(33, 100, 247)',
            },
            off:{
                border:'1px solid rgb(102, 102, 102)'
            }
        }
    },
    mounted(){
        this.$store.dispatch('AddRecipient/GetReceivers',{}) // 获取接收人列表
    },
    computed:{
        ...mapState({
            GetReceivers: (state) => {
                return state.AddRecipient.GetReceivers
            },
            CustomerInfo: (state) => {
                return state.Public.CustomerInfo
            },
        })
    },
    methods:{
        checkbox(index){
            if(index != this.checkbox_index){
                this.checkbox_index = index
            }else{
                this.checkbox_index = null
            }
        },
        submit(){
            if(this.checkbox_index){
                this.$store.dispatch(
                    'AddRecipient/ConfirmReceiver',
                    {
                        msg_id: this.CustomerInfo.msg_id,
                        buyer_nick: this.CustomerInfo.buyer_nick,
                        receiver_id: this.checkbox_index,
                        buyer_openuid: this.CustomerInfo.buyer_openuid,
                    }
                ).then((res)=>{
                    if(res.code==1000){
                        Toast('消息转发成功')
                        this.$store.commit('CustomerInfo/NOCLICK_forwarded', this.CustomerInfo.msg_id) // 同步转发状态
                        close_page() // 关闭页面
                    }else{
                        Toast(res.message)
                    }
                })
            }else{
                Toast('请选择店铺角色')
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>